import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xl-18 ant-col-xs-24" }
const _hoisted_5 = { class: "ant-col ant-col-xl-6 ant-col-xs-24" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xl-18 ant-col-xs-24" }
const _hoisted_8 = { class: "ant-col ant-col-xl-4 ant-col-xs-24" }
const _hoisted_9 = { class: "ant-col ant-col-xl-2 ant-col-xs-24" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: 900,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      "wrap-class-name": "ss-modal-cadastros"
    }, {
      title: _withCtx(() => [
        _createTextVNode("Grupo de Formação de Preço")
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
          }, _hoisted_2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_form_item, {
                      label: "Descrição",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.grupo.descricao) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.grupo.descricao]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_a_form_item, {
                      label: " ",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.grupo.tipoValor,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.grupo.tipoValor) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Percentual")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 2 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Valor")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_card, { titulo: "Itens" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_a_form_item, {
                          label: "Custo",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.descricaoCusto) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.descricaoCusto]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_a_form_item, {
                          label: "Valor",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_numerico, {
                              percentual: _ctx.state.grupo.tipoValor == 1,
                              monetario: _ctx.state.grupo.tipoValor == 2,
                              valor: _ctx.state.valorCusto,
                              "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.valorCusto) = $event))
                            }, null, 8, ["percentual", "monetario", "valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_a_form_item, {
                          label: " ",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: "ant-btn ant-btn-secondary",
                              style: {"width":"100%"},
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.inserirItem && _ctx.inserirItem(...args)))
                            }, [
                              _createVNode(_component_icone, { nome: "novo" })
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_a_table, {
                        columns: _ctx.state.colunas.filter(item => item.visible),
                        "data-source": _ctx.state.grupo.itens,
                        rowKey: "codigo",
                        pagination: false,
                        scroll: { y: 200 },
                        size: "small",
                        rowClassName: "ss-table-campos"
                      }, {
                        emptyText: _withCtx(() => [
                          _createVNode(_component_mensagem_sem_dados, { mensagem: "Nenhum item adicionado ainda" })
                        ]),
                        bodyCell: _withCtx(({ column, text, index }) => [
                          (column.key === 'acoes')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("a", {
                                  class: "visualizar",
                                  onClick: ($event: any) => (_ctx.alterarItem(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "editar" })
                                ], 8, _hoisted_12),
                                _createElementVNode("a", {
                                  class: "excluir",
                                  onClick: ($event: any) => (_ctx.excluirItem(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "excluir" })
                                ], 8, _hoisted_13)
                              ]))
                            : (column.key === 'valor')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.state.grupo.tipoValor === 1 ? _ctx.UtilitarioMascara.mascararValor(text, 2) + '%' : 'R$ ' + _ctx.UtilitarioMascara.mascararValor(text, 2)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(text), 1))
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}